const copy = {
    it: {
        label: "WhatsApp",
        helper: "Chatta ora"
    },
    en: {
        label: "WhatsApp",
        helper: "Chat now"
    }
};

const FloatingWhatsAppButton = ({
    enabled = true,
    locale = "en",
    phone = "393515699197",
    offsetClass = "bottom-[calc(1.5rem+env(safe-area-inset-bottom))]"
}) => {
    const t = copy[locale] || copy.en;

    const className = `fixed right-4 z-[9999] flex items-center gap-2 rounded-full px-4 py-3 text-xs font-semibold shadow-lg transition sm:right-6 sm:gap-3 sm:px-5 sm:text-sm ${offsetClass}`;
    const content = (
        <>
            <span className="h-2 w-2 rounded-full bg-white"></span>
            <span>{t.label}</span>
            <span className="text-xs font-normal text-emerald-100">{t.helper}</span>
        </>
    );

    if (!enabled) {
        return (
            <button
                type="button"
                className={`${className} cursor-not-allowed bg-emerald-400 text-white shadow-emerald-200`}
                aria-disabled="true"
                title="WhatsApp non attivo in questa demo"
            >
                {content}
            </button>
        );
    }

    return (
        <a
            href={`https://wa.me/${phone}`}
            target="_blank"
            rel="noreferrer"
            className={`${className} bg-emerald-600 text-white shadow-emerald-300 hover:bg-emerald-700`}
            aria-label={t.label}
        >
            {content}
        </a>
    );
};

export default FloatingWhatsAppButton;
